// src/data/exercises/L3_01.js

const accountOptions = [
  '資本金', '有価証券', '未収金', '有価証券売却益', '有価証券売却損'];

export const L3_01 = {
  title: '簿記　3級（第219-1回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

     parts: [
        { type: 'ruby', text: '保有', ruby: 'ほゆう' },
        { type: 'text', value: 'している' },
        { type: 'ruby', text: '長崎', ruby: 'ながさき' },
        { type: 'ruby', text: '株式会社', ruby: 'かぶしきがいしゃ' },
        { type: 'text', value: 'の' },
        { type: 'ruby', text: '株式', ruby: 'かぶしき' },
        { type: 'text', value: '500' },
        { type: 'ruby', text: '株', ruby: 'かぶ' },
        { type: 'text', value: '（' },
        { type: 'ruby', text: '帳簿価額', ruby: 'ちょうぼかがく' },
        { type: 'text', value: '＠￥1,000）を＠￥1,500で' },
        { type: 'ruby', text: '全株売却', ruby: 'ぜんかぶばいきゃく' },
        { type: 'text', value: 'し、' },
        { type: 'ruby', text: '代金', ruby: 'だいきん' },
        { type: 'text', value: 'は' },
        { type: 'ruby', text: '後日', ruby: 'ごじつ' },
        { type: 'ruby', text: '振', ruby: 'ふ' },
        { type: 'text', value: 'り' },
        { type: 'ruby', text: '込', ruby: 'こ' },
        { type: 'text', value: 'まれることとなった。' }
    ]

      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '未収金', debitAmount: 750000, creditAccount: '有価証券', creditAmount: 500000 },
        { debitAccount: null, debitAmount: null, creditAccount: '有価証券売却益', creditAmount: 250000 },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {

        parts: [
          { type: 'text', value: '株式500株（帳簿価額＠￥1,000）を＠￥1,500で売却し \n' },
          { type: 'text', value: '①株式を売却したので、有価証券が減少（マイナス）します。 \n' },
          { type: 'text', value: '金額は帳簿価額＠￥1,000を使います。 \n' },
          { type: 'styled', value: '有価証券の減少（マイナス）は貸方（右・Ｃｒ）に記入します。 \n\n', color: 'red', bold: true },
          { type: 'text', value: '＠￥2,800で売却し、代金は後日振り込まれることとなった。 \n' },
          { type: 'text', value: '②後日振り込まれるので、未収金が増加（プラス）します。\n' },
          { type: 'styled', value: '金額は＠￥1,500を使います。\n'},
          { type: 'styled', value: '未収金の増加（プラス）は借方（左・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '帳簿価額＠￥1,000）を＠￥1,500で売却し \n' },
          { type: 'text', value: '③帳簿価額＠￥1,000を＠￥1,500で売却しているので、 \n' },
          { type: 'text', value: 'この場合は有価証券売却益になります。 \n' },
          { type: 'styled', value: '有価証券売却益の発生は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
                ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`株式500株（帳簿価額＠￥1,000）を＠￥1,500で売却し
①株式を売却したので、有価証券が減少（マイナス）します。
金額は帳簿価額＠￥1,000を使います。

＠￥2,800で売却し、代金は後日振り込まれることとなった。
②後日振り込まれるので、未収金が増加（プラス）します。
金額は＠￥1,500を使います。

（帳簿価額＠￥1,000）を＠￥1,500で売却し
③帳簿価額＠￥1,000を＠￥1,500で売却しているので、
この場合は有価証券売却益になります。

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
           parts: [
          { type: 'text', value: '株式500株（帳簿価額＠￥1,000）を＠￥1,500で売却し \n' },
          { type: 'text', value: '①株式を売却したので、有価証券が減少（マイナス）します。 \n' },
          { type: 'text', value: '金額は帳簿価額＠￥1,000を使います。 \n' },
          { type: 'styled', value: '有価証券の減少（マイナス）は貸方（右・Ｃｒ）に記入します。 \n\n', color: 'red', bold: true },
          { type: 'text', value: '＠￥2,800で売却し、代金は後日振り込まれることとなった。 \n' },
          { type: 'text', value: '②後日振り込まれるので、未収金が増加（プラス）します。\n' },
          { type: 'styled', value: '金額は＠￥1,500を使います。\n'},
          { type: 'styled', value: '未収金の増加（プラス）は借方（左・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '帳簿価額＠￥1,000）を＠￥1,500で売却し \n' },
          { type: 'text', value: '③帳簿価額＠￥1,000を＠￥1,500で売却しているので、 \n' },
          { type: 'text', value: 'この場合は有価証券売却益になります。 \n' },
          { type: 'styled', value: '有価証券売却益の発生は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
                ]
          }
        ],
       
      },
    },
  ],
};